import { AttachInternals, Component, Element, Event, EventEmitter, h, Host, Prop } from '@stencil/core'

/**
 * ## Design System
 *
 * Para a documentação completa de design, incluindo diretrizes de uso, acessibilidade e exemplos visuais, consulte o [Design System do GovBR](https://www.gov.br/ds/components/menu?tab=designer).
 *
 * @slot icon - Slot para ícone personalizado do link.
 * @slot url - Slot para o texto ou URL exibido no link.
 */
@Component({
  tag: 'br-menu-link',
  styleUrl: 'menu-link.scss',
  shadow: true,
  formAssociated: true,
})
export class MenuLink {
  /**
   * Referência ao elemento host do componente.
   * Utilize esta propriedade para acessar e manipular o elemento do DOM associado ao componente.
   */
  @Element() el: HTMLBrMenuLinkElement

  @AttachInternals() elementInternals: ElementInternals

  /**
   * Identificador único.
   * Caso não seja fornecido, um ID gerado automaticamente será usado.
   */
  @Prop({ reflect: true }) readonly customId: string = `br-menu-link-${MenuLinkId++}`

  /**
   * URL do link
   */
  @Prop({ reflect: true }) url!: string

  /**
   * Título do link
   */
  @Prop({ reflect: true }) titulo!: string

  /**
   * Evento emitido quando o link externo é clicado
   */
  @Event() brLinkClick: EventEmitter<void>

  private handleClick = () => {
    this.brLinkClick.emit()
  }

  render() {
    return (
      <Host>
        <a href={this.url} onClick={this.handleClick}>
          <slot name="url">
            <span class="mr-1">{this.titulo}</span>
          </slot>
          <slot name="icon">
            <br-icon icon-name="fa6-solid:square-arrow-up-right" aria-hidden="true"></br-icon>
          </slot>
        </a>
      </Host>
    )
  }
}

let MenuLinkId = 0
